import { render, staticRenderFns } from "./InventoriesRegisterReportView.vue?vue&type=template&id=be932162&scoped=true&"
import script from "./InventoriesRegisterReportView.vue?vue&type=script&lang=ts&"
export * from "./InventoriesRegisterReportView.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesRegisterReportView.vue?vue&type=style&index=0&id=be932162&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be932162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
